import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { injectSpeedInsights } from '@vercel/speed-insights';

import { environment } from './environments/environment';
import { APP_BROWSER_CONFIG } from './app/app.browser.config';
import { reportWebVitals } from './app/report-web-vitals';

if (environment.production) {
  enableProdMode();
}

if (typeof document !== 'undefined') {
  injectSpeedInsights();
  document.addEventListener('DOMContentLoaded', () => {
    bootstrapApplication(AppComponent, APP_BROWSER_CONFIG)
      .then(() => reportWebVitals(console.log))
      .catch((err) => console.error(err));
  });
}
